
//const EventIndex = () => import(/* webpackChunkName: "event" */ '@/pages/event/Index');
const EventIndex = () => import(/* webpackChunkName: "event" */ '@/components/error/404');
const EventView = () => import(/* webpackChunkName: "event" */ '@/pages/event/View');
const EventEnroll = () => import(/* webpackChunkName: "event" */ '@/pages/event/Enroll');

export default function (router) {
    // 路由配置
    router.addRoutes([
        {
            path: '/event',
            component: EventIndex,
            meta: {
                title: '活动列表',
                dialog: false
            }
        },
        {
            path: '/event/:id',
            component: EventView,
            meta: {
                title: '活动详情',
                dialog: false
            }
        },
        {
            path: '/event/:id/signup',
            component: EventEnroll,
            meta: {
                title: '活动报名',
                dialog: true
            }
        },
    ]);
}